import MDBox from "../../../../components/MDBox";
import MDTypography from "../../../../components/MDTypography";
import {Checkbox, Icon} from "@mui/material";
import FormikInput from "../../../../components/FormikInput";
import {getIn} from "formik";
import {useApi} from "../../../../services/helpers";
import {useEffect, useState} from "react";
import {
  AddButton,
  CompanyPricingSection,
  CompanyPricingTitle,
  RemoveButton,
  SectionTitleText
} from "./styles";

import {
  BooleanBox,
  BooleanFieldsContainer,
  BooleanTitle,
  CheckboxItem,
  CheckboxValue,
  FieldsContainer,
  FormSection
} from "./styles";
import pxToRem from "../../../../assets/theme/functions/pxToRem";
import {CUSTOM_PRICING, NEW_GROUP_OPTION} from "./data";

const debugBorders = {}

export const GroupOptionInnerForm = ({parentPath, values, setFieldValue, formik, index, option_value, groupOptionProps}) => {
  const mapPath = `${parentPath}.${index}`
  const currentOption = getIn(values, `${parentPath}.${index}.option`)
  const api = useApi()
  const [features, setFeatures] = useState([])
  const [options, setOptions] = useState([])

  const getFeatures = ({search}) => {
    api.getFeatures({search}).then((result) => {
      if (result.kind === 'ok') {
        setFeatures(result.data.results)
      }
    })
  }

  const getOptions = (optionId, data) => {
    api.getAllOptions(optionId, data).then((result) => {
      if (result.kind === 'ok') {
        setOptions(result.data.results)
      }
    })
  }

  useEffect(() => {
    getFeatures({search: ''})

    if (currentOption?.id) {
      getOptions(currentOption?.id, {search: "", })
    }
  },[])


  return (
    <MDBox display={"flex"} flexDirection={"column"} sx={{px: 3, ...debugBorders}}>
      <MDTypography variant={"h4"} component={"h4"}>Feature #{index + 1}</MDTypography>

      <MDBox sx={FormSection} mt={pxToRem(22)}>
        <MDBox sx={FieldsContainer}>
          <FormikInput
            type={"autocomplete"}
            value={option_value?.feature}
            fieldName={`${mapPath}.feature`}
            label={"Feature"}
            options={features}
            accessKey={"name"}
            onInputChange={(value) => {
              getFeatures({search: value})
            }}
            onChange={(value, fieldName) => {
              setFieldValue(fieldName, value)
              setFieldValue(`${mapPath}.option`, null)
              getOptions(value?.id || null, {search: "", })
            }}/>

          <FormikInput
            type={"autocomplete"}
            value={option_value?.option}
            fieldName={`${mapPath}.option`}
            label={"option"}
            options={options}
            onInputChange={(value) => {
              getOptions(option_value?.feature?.id || null, {search: value})
            }}
            onChange={(value, fieldName) => {
              setFieldValue(fieldName, value)
            }}/>

        </MDBox>
      </MDBox>
      <MDBox sx={{display: 'flex', alignItems: "center", flexDirection: "row", justifyContent: "start",}}>
        <MDTypography variant={"h4"} component={"h4"}>Delete filter #{index + 1}</MDTypography>
        <Icon sx={(th) => ({...RemoveButton(th), ml: 2})} fontSize='medium'
              onClick={() => groupOptionProps.remove(index)}>
          remove_circle
        </Icon>
      </MDBox>

    </MDBox>
  )

}
export const GroupOptionForm = ({groupOptionProps, values, setFieldValue, formik, index}) => {
  const parentPath = groupOptionProps.name
  const valuesArray = getIn(values, parentPath)
  return (
    <MDBox
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'space-between'}
      alignItems={'start'}
      sx={{width: "820px", mb: 3, ...debugBorders}}
      key={'group_option_' + index} // rename later ###
    >
      <MDBox sx={CompanyPricingSection}>
        <MDTypography sx={CompanyPricingTitle}>Product Filters</MDTypography>
        <Icon sx={AddButton} fontSize='medium' onClick={() => groupOptionProps.push({...NEW_GROUP_OPTION})}>add_circle</Icon>
      </MDBox>

      {valuesArray?.length === 0 &&
        <MDBox sx={{display: 'flex', flexDirection: "column", width: "800px", px: 3, mt: 3, alignItems: 'center'}}>
          <MDTypography sx={SectionTitleText}>No filters in this product</MDTypography>
        </MDBox>
      }

      {valuesArray?.length > 0 && <MDBox sx={{display: 'flex', flexDirection: "column", width: "800px", px: 3}}>
        {valuesArray?.map((option, index) => {
            return (
              <GroupOptionInnerForm
                option_value={option}
                parentPath={parentPath}
                values={values}
                setFieldValue={setFieldValue}
                formik={formik}
                index={index}
                groupOptionProps={groupOptionProps}
                key={'option' + index}
              />

            )
          }
        )}
      </MDBox>}

    </MDBox>
  )

}
